<template>
    <div class="ai-sidebar-and-content-wrapper">
        <div class="sc__analysis__tab__box tab-content">
            <div class="sc__analysis__head__box">
                <div class="title__box">
                    <div class="head__title__group">
                        <h3 class="title">Mini - Program Plan</h3>
                        <p>Welcome to the EESAPP Work Packet</p>
                    </div>
                    <div class="print__data__btn">
                        <WorkpacketPdf :button-label="`Download`" :assessmentId="assessmentId"
                            :organizationId="organizationId" :learnerId="learnerId"
                            v-if="assessmentId && organizationId && learnerId" />
                    </div>
                </div>

                <div class="head__label__box__wrapper">
                    <div class="lable____head__title">
                        <label class="label__title">Also, see EESA Guide, Chapter 1.</label>
                    </div>
                    <div class="head__info__box">
                        <div class="info__box">
                            <p>In grid below, brainstorm some appropriate starting targets. Use task 2 info to
                                hep.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sc__analysis__data__box mini__progream__plan__wrapper">
                <div class="tabs__data__wrapper">
                    <div class="faq__questions__wrapper">
                        <div class="question__note__wrapper">
                            <h6 class="faq__title">How do echoic skills foster other language skills?</h6>
                            <div class="faq__ans__box">
                                <p>These targets could serve as echoic prompts to strengthen the same vocal
                                    response in other vocal- verbal contexts such as mand, tact, or intraverbal.
                                </p>
                            </div>
                        </div>
                        <div class="question__note__wrapper">
                            <h6 class="faq__title">Prompts will need to be faded during training, but initially
                                these prompts should be effective in evoking an echoic response.Why?</h6>
                            <div class="faq__ans__box">
                                <p>Because the targets are based on skills already demonstrated by the learner
                                    on EESAPP test items.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ai-data-container">
                <div class="rlms-flex rlms-flex-col rlms-gap-15">
                    <p class="rlms-fw-500 rlms-fs-xs rlms-text-white">Syllable Range</p>
                    <div class="rlms-flex rlms-flex-wrap rlms-justify-between rlms-gap-5 rlms-items-center">
                        <div
                            class="rlms-py-2 rlms-px-4 rlms-br-8 rlms-bg-white rlms-w-fc rlms-text-primary-500 rlms-fw-500">
                            {{ getRange }}</div>
                        <div class="rlms-py-1 rlms-px-4 rlms-br-8 rlms-bg-white rlms-w-fc rlms-fs-xxs rlms-text-primary-500 rlms-fw-500 rlms-cursor-pointer atd-for-sm-screen-btn"
                            @click="toggleAiExamples">AI Examples</div>
                    </div>
                </div>
                <div class="ai-data-info-list">
                    <div class="ai-data-info-item">
                        <p class="rlms-fs-xs">Max Syllables</p>
                        <b class="rlms-fs-xs">{{ getMaxSCVAverages?.syllable }}</b>
                    </div>
                    <div class="ai-data-info-item">
                        <p class="rlms-fs-xs">Max Diff CS</p>
                        <b class="rlms-fs-xs">{{ getMaxSCVAverages?.consonant }}</b>
                    </div>
                    <div class="ai-data-info-item">
                        <p class="rlms-fs-xs">Max Diff VS</p>
                        <b class="rlms-fs-xs">{{ getMaxSCVAverages?.vowel }}</b>
                    </div>
                </div>
                <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-flex-wrap rlms-justify-between">
                    <p class="rlms-fw-500 rlms-fs-xs rlms-text-white">Ideas for Verbal Targets</p>
                </div>
                <div class="ai-data-list">
                    <div class="ai-data-item" v-for="(item, index) in note" :key="index">
                        <div class="ai-data-item-head">
                            <p class="rlms-fw-500 rlms-fs-xs">{{ index + 1 }}. {{ item.word }}</p>
                            <div class="rlms-p-2 rlms-br-8 rlms-bg-white rlms-w-fc rlms-flex rlms-text-danger-500 rlms-fw-500 rlms-cursor-pointer"
                                @click.prevent="removeItem(index)">
                                <span class="material-symbols-outlined" style="font-size: 20px;">close</span>
                            </div>
                        </div>
                        <ul class="ai-data-item-body">
                            <li>
                                <p>Phonetic:</p>
                                <span>{{ item.ipa }}</span>
                            </li>
                            <li>
                                <p>Consonants:</p>
                                <span>{{ item.consonants }}</span>
                            </li>
                            <li>
                                <p>Vowels: </p>
                                <span>{{ item.vowels }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="ai-data-item-add-custom" @click.prevent="showAIModal = true;">
                        <span class="material-symbols-outlined">add</span>
                        <p>Add Custom</p>
                    </div>
                </div>

                <div class="rlms-py-3 rlms-px-5 rlms-br-8 rlms-bg-white rlms-w-fc rlms-text-primary-500 rlms-fw-500 rlms-cursor-pointer rlms-mx-auto"
                        @click.prevent="saveNote">Save</div>
            </div>
        </div>
        <AIExampleModal @saved="selectedExample" :syllable="getMaxSCVAverages?.syllable"
            :consonants="getMaxSCVAverages?.consonant" :vowel="getMaxSCVAverages?.vowel"
            :preferences_list="preferences_list" :selectedItems="note" :loadExample="aiExampleShowing"
            :known_syllables="knownSyllables" />
        <CustomMiniProgramItemModal v-if="showAIModal" @close="showAIModal = false" @saved="customItem"
            :selectedItems="note" />
    </div>
</template>
<script setup>
import { ref, onMounted, computed, inject } from 'vue';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { handleError } from '@/utils/handleError';
import { showDialog } from '@/utils/swal';
import AIExampleModal from '../AIExampleModal.vue';
import WorkpacketPdf from './WorkpacketPdf.vue';
import { authrizedPermissions } from '@/utils/permissions';
import CustomMiniProgramItemModal from './CustomMiniProgramItemModal.vue';

const props = defineProps({
    organizationId: Number,
    assessmentId: Number,
    learnerId: Number,
    canConductAssessment: Boolean,
});

const loader = useLoaderStore();
const originalNote = ref(null);

// Register with parent for unsaved changes tracking
const registerUnsavedCheck = inject('registerUnsavedCheck', null);
const hasUnsavedChanges = () => {
    if (!originalNote.value) return false;
    return JSON.stringify(note.value) !== JSON.stringify(originalNote.value);
};
if (registerUnsavedCheck) {
    registerUnsavedCheck(hasUnsavedChanges);
}

const groupScores = ref({ 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 });
const scvAverages = ref({
    1: { syllable: '-', consonant: '-', vowel: '-' },
    2: { syllable: '-', consonant: '-', vowel: '-' },
    3: { syllable: '-', consonant: '-', vowel: '-' },
});

const preferences_list = ref({
    activities: "",
    items: "",
    places: ""
});

const note = ref([]);
const assessment = ref(null);
const knownSyllables = ref([]);

const showAIModal = ref(false);

// Vowel and consonant mappings (from SyllableTracker.vue)
const vowels = [
    { symbol: "i", short: "ee" },
    { symbol: "ɪ", short: "ih" },
    { symbol: "e", short: "ay" },
    { symbol: "ɛ", short: "eh" },
    { symbol: "æ", short: "(none)" },
    { symbol: "a", short: "ah" },
    { symbol: "ʌ or ə", short: "uh" },
    { symbol: "ʊ", short: "(none)" },
    { symbol: "ɔ", short: "aw" },
    { symbol: "o", short: "oh" },
    { symbol: "u", short: "oo" },
    { symbol: "au", short: "ow" },
    { symbol: "aɪ", short: "ai" },
    { symbol: "oɪ", short: "oi" },
];

const consonantRows = [
    { label: "w or wh", code: "wh" },
    { label: "h", code: "h" },
    { label: "p or b", code: "pb" },
    { label: "t or d", code: "td" },
    { label: "k or g", code: "kg" },
    { label: "m", code: "m" },
    { label: "n", code: "n" },
    { label: "ng or ŋ", code: "ngŋ" },
    { label: "f or v", code: "fv" },
    { label: "l", code: "l" },
    { label: "y or j", code: "yj" },
];

// Extract known syllables from workpacket data
const extractKnownSyllables = (workpacket) => {
    const known = [];

    // From automated syllableTracker (test results)
    if (workpacket?.syllableTracker) {
        Object.entries(workpacket.syllableTracker).forEach(([combo, score]) => {
            if (score === 1) {
                known.push(combo);
            }
        });
    }

    // From manual consonant+vowel selections
    if (workpacket?.manualSyllableTracker) {
        Object.entries(workpacket.manualSyllableTracker).forEach(([indexNo, jsonStr]) => {
            try {
                const parsed = JSON.parse(jsonStr);
                // Find which consonant and vowel this index corresponds to
                const idx = parseInt(indexNo) - 1;
                const cIndex = Math.floor(idx / vowels.length);
                const vIndex = idx % vowels.length;

                if (cIndex >= 0 && cIndex < consonantRows.length && vIndex >= 0 && vIndex < vowels.length) {
                    const consonantLabel = consonantRows[cIndex].label;
                    const vowelShort = vowels[vIndex].short;

                    // Check if both consonant and vowel are marked
                    const consonants = consonantLabel.split(/or/i).map(s => s.trim().toLowerCase());
                    const hasConsonant = consonants.some(c => parsed[c] == '1');
                    const hasVowel = parsed[vowelShort] == '1';

                    if (hasConsonant && hasVowel) {
                        // Add the first consonant + vowel combination
                        const firstConsonant = consonants.find(c => parsed[c] == '1') || consonants[0];
                        known.push(`${firstConsonant}${vowelShort}`);
                    }
                }
            } catch (e) {
                // Skip invalid JSON
            }
        });
    }

    // From manual vowel-only selections (top row)
    if (workpacket?.manualSyllableTrackerVowel) {
        Object.entries(workpacket.manualSyllableTrackerVowel).forEach(([indexNo, jsonStr]) => {
            try {
                const parsed = JSON.parse(jsonStr);
                const vIndex = parseInt(indexNo) - 1;
                if (vIndex >= 0 && vIndex < vowels.length) {
                    const vowelShort = vowels[vIndex].short;
                    if (parsed[vowelShort] == '1' && vowelShort !== '(none)') {
                        known.push(vowelShort);
                    }
                }
            } catch (e) {
                // Skip invalid JSON
            }
        });
    }

    return [...new Set(known)]; // Remove duplicates
};

const fetchAssessment = async () => {
    loader.show();
    try {
        // Fetch assessment data
        const { data } = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}`);
        assessment.value = data?.data || null
        note.value = data?.data?.note?.mini_program_plan ? JSON.parse(data?.data?.note?.mini_program_plan) : [];
        const preferences_listnote = data?.data?.note?.preferences_list;
        preferences_list.value = (preferences_listnote) ? JSON.parse(preferences_listnote) : {
            activities: "",
            items: "",
            places: ""
        }

        const groupScoreData = data?.data?.result?.group_scores || {};
        const scvAverageData = data?.data?.result?.scv_averages || {};

        for (let i = 1; i <= 5; i++) {
            const scoreObj = groupScoreData[i];
            groupScores.value[i] = scoreObj?.total > 0 ? (scoreObj.score_one / scoreObj.total) * 100 : 0;

            if (scvAverageData?.[i] && i <= 3) {
                scvAverages.value[i] = scvAverageData?.[i];
            }
        }

        // Fetch workpacket data for syllable tracker
        const workpacketResponse = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/workpacket`);
        const workpacketData = workpacketResponse.data?.data || null;
        knownSyllables.value = extractKnownSyllables(workpacketData);

        // Store original data for unsaved changes detection
        originalNote.value = JSON.parse(JSON.stringify(note.value));

    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const getRange = computed(() => {
    const scores = groupScores.value ?? [];

    const g1 = scores[1] ?? 0;
    const g2 = scores[2] ?? 0;
    const g3 = scores[3] ?? 0;
    const g4 = scores[4] ?? 0;
    const g5 = scores[5] ?? 0;

    if (g1 >= 80 && g2 >= 80 && g3 >= 80 && g4 < 80) {
        return '2 - 3';
    }

    if (g1 >= 80 && g2 >= 80 && g3 >= 80 && g4 >= 80 && g5 < 80) {
        return '3 - 4';
    }

    if (g1 >= 80 && g2 >= 80 && g3 >= 80 && g4 >= 80 && g5 >= 80) {
        return '4 - 5';
    }

    return '  -  ';
});

const getMaxSCVAverages = computed(() => {
    const values = Object.values(scvAverages.value);

    const maxSyllable = Math.max(
        ...values.map(v => parseFloat(v.syllable) || 0)
    );
    const maxConsonant = Math.max(
        ...values.map(v => parseFloat(v.consonant) || 0)
    );
    const maxVowel = Math.max(
        ...values.map(v => parseFloat(v.vowel) || 0)
    );

    return {
        syllable: maxSyllable,
        consonant: maxConsonant,
        vowel: maxVowel
    };
});

const saveNote = async () => {
    if (!props.canConductAssessment) {
        let message = `You don’t have permission perform this action.`;
        const learner = assessment.value?.learner;
        if (learner?.is_administrator) {
            message = `You don’t have permission perform this action because it was created before you were granted administrator access.`;
        } else if (learner?.is_authorized_user) {
            if (learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission perform this action because it was created before you were granted group access.`;
            } else if (!learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission perform this action.`;
            }
        }

        showDialog({ icon: 'warning', html: message });
        return;
    }

    loader.show();
    try {
        await api.post(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/notes`, {
            mini_program_plan: JSON.stringify(note.value)
        });

        // Update original data after successful save
        originalNote.value = JSON.parse(JSON.stringify(note.value));

        showDialog({
            title: 'Success',
            icon: 'success',
            html: 'Note saved successfully!'
        });
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

onMounted(() => fetchAssessment());

const selectedExample = (example) => {
    note.value = [...note.value, ...example];

    if(aiExampleShowing.value) {
        const el = document.getElementById('aiExamples');
        el.style.display = 'none';

        const el1 = document.getElementById('atd-for-sm-list');
        el1.style.display = 'none';
        
        document.body.style.overflow = '';
    }
}

const customItem = (example) => {
    note.value = [...note.value, example];
}

const removeItem = (indexToRemove) => {
    if (indexToRemove > -1 && indexToRemove < note.value.length) {
        note.value.splice(indexToRemove, 1);
    }
}

const aiExampleShowing = ref(false);

const toggleAiExamples = () => {
    const el = document.getElementById('aiExamples');
    el.style.display = 'flex';

    const el1 = document.getElementById('atd-for-sm-list');
    el1.style.display = 'flex';
    
    document.body.style.overflow = 'hidden';

    aiExampleShowing.value = true
};
</script>